exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custome_frm {\n  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */\n  min-height: 390px;\n}\n.custome_switch{\n  padding: 13px !important;\n}\n.custome_switch:before {\n  top: 3px !important;\n}\n.custom-tableheader .card-body {\n  background-color: #fefefe !important;\n}\n.custome_btn {\n  position: relative;\n  top: 26px;\n}\n.tagtable .table-secondary > td {\n  background-color: #2a3042 !important;\n}\n.custome_txt{\n  position: relative;\n  top: 18px;\n  color: #666666;\n  font-weight: 600;\n}\n", ""]);

// exports
